/* A few short notes under a product's price (website_hq/item_notes.py): a small label, a line of words, and a link where the note leads to a page.
 * Everything arrives as plain text and is written with textContent, so nothing an app or the settings send can become markup. The one exception is a note's icon: the server answers it from
 * its own icon set (website_hq/icons.py), and it is read as an image, never as page markup. When the notes carry icons they show as a row of small badges. Nothing is added when there are none. */

import { isPdp, getPdpItemCode } from './pdp_context.js';

frappe.ready(function () {
	if (!isPdp()) return;
	var itemCode = getPdpItemCode();
	if (!itemCode) return;

	frappe.call({
		method: 'raftor_websitehq.website_hq.item_notes.for_item',
		args: { item_code: itemCode },
		callback: function (r) {
			var notes = (r && r.message) || [];
			if (!notes.length || document.querySelector('.rfhq-pdp-notes')) return;
			var anchor = document.querySelector('.product-container.item-main .product-details') || document.querySelector('.product-container.item-main');
			if (!anchor) return;

			// Notes with an icon are a row of badges; the others (a link to a policy, say) stay a plain line of notes under it.
			var badges = document.createElement('ul'); badges.className = 'rfhq-pdp-notes rfhq-pdp-notes--badges';
			var plain = document.createElement('ul'); plain.className = 'rfhq-pdp-notes';
			var list = document.createElement('div'); list.className = 'rfhq-pdp-notes-set';
			notes.forEach(function (note) {
				var item = document.createElement('li');
				if (note.icon) {
					var image = new DOMParser().parseFromString(note.icon, 'image/svg+xml').documentElement;
					if (image && image.nodeName === 'svg') { image = document.importNode(image, true); image.setAttribute('class', 'rfhq-pdp-note__icon'); item.appendChild(image); }
				}
				var words = document.createElement('span'); words.className = 'rfhq-pdp-note__words';
				var title = document.createElement(note.href ? 'a' : 'span');
				title.className = 'rfhq-pdp-note__title';
				title.textContent = note.title;
				if (note.href) { title.href = note.href; if (/^https:/.test(note.href)) { title.target = '_blank'; title.rel = 'noopener noreferrer'; } }
				words.appendChild(title);
				if (note.text) {
					var text = document.createElement('span');
					text.className = 'rfhq-pdp-note__text';
					text.textContent = note.text;
					words.appendChild(text);
				}
				item.appendChild(words);
				(note.icon ? badges : plain).appendChild(item);
			});
			[badges, plain].forEach(function (part) { if (part.children.length) list.appendChild(part); });
			// Under the price and the buy button: the block of the details column that holds the cart row. The shop draws that row after the page loads,
			// so wait for it; if it never comes, the notes go above the product's description.
			var placed = false;
			function place() {
				if (placed) return true;
				var block = anchor.querySelector('.item-cart');
				while (block && block.parentElement !== anchor) block = block.parentElement;
				if (!block) return false;
				anchor.insertBefore(list, block.nextSibling);
				placed = true;
				return true;
			}
			if (place()) return;
			var watcher = new MutationObserver(function () { if (place()) watcher.disconnect(); });
			watcher.observe(anchor, { childList: true, subtree: true });
			setTimeout(function () {
				watcher.disconnect();
				if (placed) return;
				var description = anchor.querySelector('.product-description');
				if (description) anchor.insertBefore(list, description); else anchor.appendChild(list);
				placed = true;
			}, 4000);
		},
	});
});
